import styled from 'styled-components'

import { Text } from '../text'

import { FOOTER_MIN_HEIGHT } from '../footer'

import { Color } from '../../theme/color'
import type { ColorKeys } from '../../theme/color'

interface NoticeContainerProps {
  title?: string
  list?: any[]
  isFooter?: boolean
  $backgroundColor?: ColorKeys
}

export function NoticeContainer({ title, list, isFooter = true, $backgroundColor }: NoticeContainerProps) {
  return (
    <Container isFooter={isFooter} $backgroundColor={$backgroundColor}>
      {title && (
        <Text size={14} weight={600}>
          {title}
        </Text>
      )}
      {list && (
        <ul>
          {list.map((notice, index) => {
            if (typeof notice === 'string') {
              return (
                <ListItem key={index}>
                  •
                  <Text size={14} lineHeight={22} color="text_secondary">
                    {notice}
                  </Text>
                </ListItem>
              )
            }
            return <ListItem key={index}>• {notice}</ListItem>
          })}
        </ul>
      )}
    </Container>
  )
}

const Container = styled.div<Pick<NoticeContainerProps, 'isFooter' | '$backgroundColor'>>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  ${({ isFooter }) => (isFooter ? `padding-bottom: ${FOOTER_MIN_HEIGHT}px;` : '')}
  ${({ $backgroundColor }) => ($backgroundColor ? `background-color: ${Color[$backgroundColor]};` : '')}
  li {
    list-style: none;
  }
`

const ListItem = styled.li`
  display: flex;
  gap: 4px;
  color: ${Color.text_secondary};
`
